import axios from 'axios';
import config from '../config';
import {
  CREATE_VISION_REQUEST, CREATE_VISION_SUCCESS, CREATE_VISION_FAIL,
  GET_VISIONS_REQUEST, GET_VISIONS_SUCCESS, GET_VISIONS_FAIL,
  GET_VISION_REQUEST, GET_VISION_SUCCESS, GET_VISION_FAIL,
  UPDATE_VISION_REQUEST, UPDATE_VISION_SUCCESS, UPDATE_VISION_FAIL,
  DELETE_VISION_REQUEST, DELETE_VISION_SUCCESS, DELETE_VISION_FAIL,
  CREATE_NODE_REQUEST, CREATE_NODE_SUCCESS, CREATE_NODE_FAIL,
  UPDATE_NODE_REQUEST, UPDATE_NODE_SUCCESS, UPDATE_NODE_FAIL,
  DELETE_NODE_REQUEST, DELETE_NODE_SUCCESS, DELETE_NODE_FAIL,
  CREATE_CONNECTION_REQUEST, CREATE_CONNECTION_SUCCESS, CREATE_CONNECTION_FAIL,
  DELETE_CONNECTION_REQUEST, DELETE_CONNECTION_SUCCESS, DELETE_CONNECTION_FAIL,
  PLANNING_CHAT_REQUEST, PLANNING_CHAT_SUCCESS, PLANNING_CHAT_FAIL,
  ONBOARD_REQUEST, ONBOARD_SUCCESS, ONBOARD_FAIL,
  SUGGEST_NODES_REQUEST, SUGGEST_NODES_SUCCESS, SUGGEST_NODES_FAIL,
} from '../constants/planningConstants';

const base = config.apiUrl;
const cfg = { withCredentials: true };

// ─── Visions ────────────────────────────────────────────────────────────────

export const createVision = (data) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_VISION_REQUEST });
    const res = await axios.post(`${base}/api/v1/planning/visions`, data, cfg);
    dispatch({ type: CREATE_VISION_SUCCESS, payload: res.data.vision });
    return res.data;
  } catch (err) {
    dispatch({ type: CREATE_VISION_FAIL, payload: err.response?.data?.message || err.message });
    throw err;
  }
};

export const getMyVisions = () => async (dispatch) => {
  try {
    dispatch({ type: GET_VISIONS_REQUEST });
    const res = await axios.get(`${base}/api/v1/planning/visions`, cfg);
    dispatch({ type: GET_VISIONS_SUCCESS, payload: res.data.visions });
    return res.data;
  } catch (err) {
    dispatch({ type: GET_VISIONS_FAIL, payload: err.response?.data?.message || err.message });
    throw err;
  }
};

export const getVision = (id) => async (dispatch) => {
  try {
    dispatch({ type: GET_VISION_REQUEST });
    const res = await axios.get(`${base}/api/v1/planning/visions/${id}`, cfg);
    dispatch({ type: GET_VISION_SUCCESS, payload: res.data });
    return res.data;
  } catch (err) {
    dispatch({ type: GET_VISION_FAIL, payload: err.response?.data?.message || err.message });
    throw err;
  }
};

export const updateVision = (id, data) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_VISION_REQUEST });
    const res = await axios.patch(`${base}/api/v1/planning/visions/${id}`, data, cfg);
    dispatch({ type: UPDATE_VISION_SUCCESS, payload: res.data.vision });
    return res.data;
  } catch (err) {
    dispatch({ type: UPDATE_VISION_FAIL, payload: err.response?.data?.message || err.message });
    throw err;
  }
};

export const deleteVision = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_VISION_REQUEST });
    await axios.delete(`${base}/api/v1/planning/visions/${id}`, cfg);
    dispatch({ type: DELETE_VISION_SUCCESS, payload: id });
  } catch (err) {
    dispatch({ type: DELETE_VISION_FAIL, payload: err.response?.data?.message || err.message });
    throw err;
  }
};

// ─── Nodes ──────────────────────────────────────────────────────────────────

export const createNode = (visionId, data) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_NODE_REQUEST });
    const res = await axios.post(`${base}/api/v1/planning/visions/${visionId}/nodes`, data, cfg);
    dispatch({ type: CREATE_NODE_SUCCESS, payload: res.data.node });
    return res.data;
  } catch (err) {
    dispatch({ type: CREATE_NODE_FAIL, payload: err.response?.data?.message || err.message });
    throw err;
  }
};

export const updateNode = (id, data) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_NODE_REQUEST });
    const res = await axios.patch(`${base}/api/v1/planning/nodes/${id}`, data, cfg);
    dispatch({ type: UPDATE_NODE_SUCCESS, payload: res.data.node });
    return res.data;
  } catch (err) {
    dispatch({ type: UPDATE_NODE_FAIL, payload: err.response?.data?.message || err.message });
    throw err;
  }
};

export const deleteNode = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_NODE_REQUEST });
    await axios.delete(`${base}/api/v1/planning/nodes/${id}`, cfg);
    dispatch({ type: DELETE_NODE_SUCCESS, payload: id });
  } catch (err) {
    dispatch({ type: DELETE_NODE_FAIL, payload: err.response?.data?.message || err.message });
    throw err;
  }
};

export const suggestActionsForMilestone = (milestoneId) => async (dispatch) => {
  try {
    dispatch({ type: SUGGEST_NODES_REQUEST });
    const res = await axios.post(`${base}/api/v1/planning/milestones/${milestoneId}/suggest-actions`, {}, cfg);
    dispatch({ type: SUGGEST_NODES_SUCCESS, payload: res.data.suggestions });
    return res.data;
  } catch (err) {
    dispatch({ type: SUGGEST_NODES_FAIL, payload: err.response?.data?.message || err.message });
    throw err;
  }
};

// ─── Connections ─────────────────────────────────────────────────────────────

export const createConnection = (visionId, data) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_CONNECTION_REQUEST });
    const res = await axios.post(`${base}/api/v1/planning/visions/${visionId}/connections`, data, cfg);
    dispatch({ type: CREATE_CONNECTION_SUCCESS, payload: res.data.connection });
    return res.data;
  } catch (err) {
    dispatch({ type: CREATE_CONNECTION_FAIL, payload: err.response?.data?.message || err.message });
    throw err;
  }
};

export const deleteConnection = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_CONNECTION_REQUEST });
    await axios.delete(`${base}/api/v1/planning/connections/${id}`, cfg);
    dispatch({ type: DELETE_CONNECTION_SUCCESS, payload: id });
  } catch (err) {
    dispatch({ type: DELETE_CONNECTION_FAIL, payload: err.response?.data?.message || err.message });
    throw err;
  }
};

// ─── AI / Chat ────────────────────────────────────────────────────────────────

export const getChatHistory = (visionId, sessionId) => async () => {
  const res = await axios.get(`${base}/api/v1/planning/visions/${visionId}/chat/${sessionId}`, cfg);
  return res.data;
};

export const planningChat = (visionId, data) => async (dispatch) => {
  try {
    dispatch({ type: PLANNING_CHAT_REQUEST });
    const res = await axios.post(`${base}/api/v1/planning/visions/${visionId}/chat`, data, cfg);
    dispatch({ type: PLANNING_CHAT_SUCCESS, payload: res.data });
    return res.data;
  } catch (err) {
    dispatch({ type: PLANNING_CHAT_FAIL, payload: err.response?.data?.message || err.message });
    throw err;
  }
};

export const onboardChat = (data) => async (dispatch) => {
  try {
    dispatch({ type: ONBOARD_REQUEST });
    const res = await axios.post(`${base}/api/v1/planning/onboard`, data, cfg);
    dispatch({ type: ONBOARD_SUCCESS, payload: res.data });
    return res.data;
  } catch (err) {
    dispatch({ type: ONBOARD_FAIL, payload: err.response?.data?.message || err.message });
    throw err;
  }
};

export const suggestNodes = (visionId) => async (dispatch) => {
  try {
    dispatch({ type: SUGGEST_NODES_REQUEST });
    const res = await axios.post(`${base}/api/v1/planning/visions/${visionId}/suggest`, {}, cfg);
    dispatch({ type: SUGGEST_NODES_SUCCESS, payload: res.data.suggestions });
    return res.data;
  } catch (err) {
    dispatch({ type: SUGGEST_NODES_FAIL, payload: err.response?.data?.message || err.message });
    throw err;
  }
};

export const rebuildContext = (visionId) => async () => {
  const res = await axios.post(`${base}/api/v1/planning/visions/${visionId}/context/rebuild`, {}, cfg);
  return res.data;
};

export const saveJournal = (visionId, journal) => async (dispatch, getState) => {
  const res = await axios.patch(`${base}/api/v1/planning/visions/${visionId}/journal`, { journal }, cfg);
  // Patch activeVision in Redux so remounting Journal reads fresh content
  const { activeVision } = getState().planning;
  if (activeVision && activeVision._id.toString() === visionId.toString()) {
    dispatch({ type: UPDATE_VISION_SUCCESS, payload: { ...activeVision, journal: res.data.journal } });
  }
  return res.data;
};

export const draftNodeBody = (nodeId) => async () => {
  const res = await axios.post(`${base}/api/v1/planning/nodes/${nodeId}/draft-body`, {}, cfg);
  return res.data;
};

export const addNodeUpdate = (nodeId, text) => async () => {
  const res = await axios.post(`${base}/api/v1/planning/nodes/${nodeId}/updates`, { text }, cfg);
  return res.data;
};

export const deleteNodeUpdate = (nodeId, updateId) => async () => {
  const res = await axios.delete(`${base}/api/v1/planning/nodes/${nodeId}/updates/${updateId}`, cfg);
  return res.data;
};

export const getExecutionSummary = (visionId) => async () => {
  const res = await axios.get(`${base}/api/v1/planning/visions/${visionId}/summary`, cfg);
  return res.data;
};

export const generateExecutionSummary = (visionId) => async () => {
  const res = await axios.post(`${base}/api/v1/planning/visions/${visionId}/summary`, {}, cfg);
  return res.data;
};

// ─── Planning todos ───────────────────────────────────────────────────────────

export const fetchPlanningTodos = (visionId) => async () => {
  const res = await axios.get(`${base}/api/v1/planning/visions/${visionId}/todos`, cfg);
  return res.data;
};

export const createPlanningTodo = (visionId, data) => async () => {
  const res = await axios.post(`${base}/api/v1/planning/visions/${visionId}/todos`, data, cfg);
  return res.data;
};

export const updatePlanningTodo = (todoId, data) => async () => {
  const res = await axios.patch(`${base}/api/v1/planning/todos/${todoId}`, data, cfg);
  return res.data;
};

export const deletePlanningTodo = (todoId) => async () => {
  const res = await axios.delete(`${base}/api/v1/planning/todos/${todoId}`, cfg);
  return res.data;
};

export const generateTodosFromNodes = (visionId, nodeIds) => async () => {
  const body = nodeIds && nodeIds.length > 0 ? { nodeIds } : { autoSelect: true };
  const res = await axios.post(`${base}/api/v1/planning/visions/${visionId}/todos/generate`, body, cfg);
  return res.data;
};

// ─── Resources (documents) ──────────────────────────────────────────────────

export const fetchResources = (visionId, nodeId) => async () => {
  const q = nodeId ? `?nodeId=${nodeId}` : '';
  const res = await axios.get(`${base}/api/v1/planning/visions/${visionId}/resources${q}`, cfg);
  return res.data;
};

export const getResource = (id) => async () => {
  const res = await axios.get(`${base}/api/v1/planning/resources/${id}`, cfg);
  return res.data;
};

export const createResource = (visionId, data) => async () => {
  const res = await axios.post(`${base}/api/v1/planning/visions/${visionId}/resources`, data, cfg);
  return res.data;
};

// Create (or reuse) a "thinking doc" spun off a todo.
export const createThinkingDoc = (visionId, todoId) => async () => {
  const res = await axios.post(`${base}/api/v1/planning/visions/${visionId}/todos/${todoId}/thinking-doc`, {}, cfg);
  return res.data;
};

export const updateResource = (id, data) => async () => {
  const res = await axios.patch(`${base}/api/v1/planning/resources/${id}`, data, cfg);
  return res.data;
};

export const deleteResource = (id) => async () => {
  const res = await axios.delete(`${base}/api/v1/planning/resources/${id}`, cfg);
  return res.data;
};

export const createPlanSummary = (visionId) => async () => {
  const res = await axios.post(`${base}/api/v1/planning/visions/${visionId}/plan-summary`, {}, cfg);
  return res.data;
};

export const draftResourceBody = (id, instructions) => async () => {
  const res = await axios.post(`${base}/api/v1/planning/resources/${id}/draft`, { instructions: instructions || '' }, cfg);
  return res.data;
};

// ─── Habits ─────────────────────────────────────────────────────────────────

export const fetchHabits = (visionId, { archived = false } = {}) => async () => {
  const q = archived ? '?archived=true' : '';
  const res = await axios.get(`${base}/api/v1/planning/visions/${visionId}/habits${q}`, cfg);
  return res.data;
};

export const createHabit = (visionId, data) => async () => {
  const res = await axios.post(`${base}/api/v1/planning/visions/${visionId}/habits`, data, cfg);
  return res.data;
};

export const updateHabit = (id, data) => async () => {
  const res = await axios.patch(`${base}/api/v1/planning/habits/${id}`, data, cfg);
  return res.data;
};

export const deleteHabit = (id) => async () => {
  const res = await axios.delete(`${base}/api/v1/planning/habits/${id}`, cfg);
  return res.data;
};

export const toggleHabitLog = (id, date) => async () => {
  const res = await axios.post(`${base}/api/v1/planning/habits/${id}/toggle`, { date }, cfg);
  return res.data;
};

export const generateHabits = (visionId) => async () => {
  const res = await axios.post(`${base}/api/v1/planning/visions/${visionId}/habits/generate`, {}, cfg);
  return res.data;
};

// ─── Side Quests ────────────────────────────────────────────────────────────

export const fetchSideQuests = () => async () => {
  const res = await axios.get(`${base}/api/v1/planning/side-quests`, cfg);
  return res.data;
};

export const createSideQuest = (data) => async () => {
  const res = await axios.post(`${base}/api/v1/planning/side-quests`, data, cfg);
  return res.data;
};

export const updateSideQuest = (id, data) => async () => {
  const res = await axios.patch(`${base}/api/v1/planning/side-quests/${id}`, data, cfg);
  return res.data;
};

export const deleteSideQuest = (id) => async () => {
  const res = await axios.delete(`${base}/api/v1/planning/side-quests/${id}`, cfg);
  return res.data;
};
